import React from "react";
import { Box, ButtonPrimary, Grid, skinVars, Stack, Text2, Text4, useScreenSize } from "@telefonica/mistica";
import { observer } from "mobx-react-lite";

interface IProps {
	icon?: React.ReactNode;
	title?: string;
	description?: string;
	button?: boolean;
	textButton?: string;
	additionalSpace?: boolean;
	onPress?(): Promise<void> | void;
}

export const CardWithBorder: React.FC<IProps> = observer((props) => {
	const { icon, title, description, onPress, textButton, button = false, additionalSpace } = props;
	const { isDesktopOrBigger } = useScreenSize();

	return (
		<Box
			className="card-with-border"
			paddingTop={24}
			paddingLeft={isDesktopOrBigger ? 24 : 16}
			paddingRight={8}
			paddingBottom={isDesktopOrBigger ? 0 : additionalSpace ? 32 : 24}
		>
			<Grid height={additionalSpace ? 211 : 172}>
				<Stack space={16}>
					{icon}
					<Stack space={8}>
						<Text4 regular color={skinVars.colors.textPrimary}>
							{title}
						</Text4>
						<Text2 regular color={skinVars.colors.textSecondary}>
							{description}
						</Text2>
						{button && (
							<Box paddingTop={8}>
								<ButtonPrimary small onPress={onPress as () => Promise<void> | void}>
									<Text2 medium color={skinVars.colors.textButtonPrimary}>
										{textButton}
									</Text2>
								</ButtonPrimary>
							</Box>
						)}
					</Stack>
				</Stack>
			</Grid>
		</Box>
	);
});
